<template>
  <base-form :can-back="canBack">
    <slot />
    <template #submit-button>
      <update-button class="px-5" />
    </template>
    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import UpdateButton from '@/views/molecules/buttons/UpdateButton'

export default {
  name: "EditorForm",
  components: {
    BaseForm,
    UpdateButton,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
